import React from 'react';
import { postLog } from './api';
import { normalizeLogError } from './utils/helpers';

export class ErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    postLog('Falha no app', normalizeLogError(error, errorInfo));
  }

  render() {
    return this.props.children;
  }
}
